// One colour per campaign, in the order the comparison names them. Shared by
// every widget on the page, so a campaign is the same colour in the Comparing
// chips, the metric table's heading, and every chart below it.
//
// The first two are the pair the two-campaign report already uses, so a
// comparison that grows from two to three does not repaint what was there.
export const CAMPAIGN_COLORS = ['#71717a', '#3b82f6', '#14b8a6', '#f5a623']

// The design is drawn for up to four. A fifth would have no colour, and the
// metric table's columns would be too narrow to hold a number at 24px.
export const MAX_COMPARED = CAMPAIGN_COLORS.length

export const campaignColor = (index: number) =>
  CAMPAIGN_COLORS[index % CAMPAIGN_COLORS.length]
